import { Injectable, Inject } from '@angular/core';
import { DOCUMENT } from '@angular/common';

import { environment } from 'src/environments/environment';

declare let gtag: any;
declare let ga: any;
declare let ytag: any;
declare var window: any;

@Injectable({
  providedIn: 'root'
})
export class TrackingService {

  constructor(@Inject(DOCUMENT) private dom) {
    this.loadGtag();
    this.loadGA();
    this.loadGoogleTagManager();
    this.loadYtag();
    this.loadFacebookPixelCode();
  }

  private useGA(): boolean {
    return typeof gtag !== 'undefined';
  }

  private loadGtag() {
    if (typeof window === 'undefined') {
      return;
    }
    const scriptElement = this.dom.createElement('script');
    scriptElement.setAttribute('src', `https://www.googletagmanager.com/gtag/js?id=${environment.gaId}`);
    scriptElement.setAttribute('async', true);
    this.dom.body.appendChild(scriptElement);

    window.dataLayer = window.dataLayer || [];
    // ここをアローファンクションに置き換えると、動かなくなるので注意
    // tslint:disable-next-line: only-arrow-functions
    window.gtag = function() {
        window.dataLayer.push(arguments);
    };
    gtag('js', new Date());
    gtag('config', environment.analyticsId, { send_page_view: false });
    gtag('config', environment.gaId);
    gtag('config', environment.googleAdsId);
  }

  private loadGA() {
    if (typeof document === 'undefined') {
      return;
    }
    const script = document.createElement('script');
    script.innerHTML = `
      (function(i,s,o,g,r,a,m){i['GoogleAnalyticsObject']=r;i[r]=i[r]||function(){
      (i[r].q=i[r].q||[]).push(arguments)},i[r].l=1*new Date();a=s.createElement(o),
      m=s.getElementsByTagName(o)[0];a.async=1;a.src=g;m.parentNode.insertBefore(a,m)
      })(window,document,'script','https://www.google-analytics.com/analytics.js','ga');

      ga('create', '` + environment.analyticsId + `', 'auto');
    `;
    document.head.appendChild(script);
  }

  sendPageView(url: string, title: string): void {
    if (!this.useGA()) {
      return;
    }
    if (!url.startsWith('/')) {
      url = `/${url}`;
    }
    gtag('config', environment.analyticsId, {
        page_path: url,
        page_title: title,
      });
  }

  sendEvent(eventName: string, eventCategory: string, eventAction: string, eventLabel: any): void {
    if (!this.useGA()) {
      return;
    }
    gtag('event', eventName, {
      event_category: eventCategory,
      event_action: eventAction,
      event_label: eventLabel
    });
  }

  sendSNS(type: string, target: string) {
    if (!window.gtag) {
      return;
    }
    gtag('event', 'share', {
      method: type,
      content_type: 'image',
      item_id: target,
    });
  }

  sendAdsTelEvent(url: string) {
    if (!this.useGA()) {
      return;
    }
    const callback = () => {
      this.sendYahooAdsConversion();
      if (typeof(url) !== 'undefined') {
        // Yahoo広告のコンバージョンタグにcallback指定が無いため、setTimeoutで少し遅延してから実行
        setTimeout(() => {
          location.href = url;
        }, 200);
      }
    };
    gtag('event', 'conversion', {
      send_to: environment.googleAdsTelConversion,
      event_callback: callback
    });
  }

  private loadGoogleTagManager() {
    if (typeof document === 'undefined') {
      return;
    }
    const script = document.createElement('script');
    script.innerHTML = `
      (function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
      new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
      j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
      'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
      })(window,document,'script','dataLayer','${environment.googleTagManagerId}');
    `;
    document.head.appendChild(script);
  }

  private sendYahooAdsConversion() {
    ytag({
      type: 'yjad_conversion',
      config: {
        yahoo_ydn_conv_io: environment.yahooYdnConvIo,
        yahoo_ydn_conv_label: environment.yahooYdnConvLabel,
        yahoo_ydn_conv_transaction_id: '',
        yahoo_ydn_conv_value: '0',
      }
    });
  }

  private loadYtag() {
    if (typeof window === 'undefined') {
      return;
    }
    const scriptElement = this.dom.createElement('script');
    scriptElement.setAttribute('src', 'https://s.yimg.jp/images/listing/tool/cv/ytag.js');
    scriptElement.setAttribute('async', true);
    this.dom.body.appendChild(scriptElement);

    window.yjDataLayer = window.yjDataLayer || [];
    // ここをアローファンクションに置き換えると、動かなくなるので注意
    // tslint:disable-next-line: only-arrow-functions
    window.ytag = function() {
      window.yjDataLayer.push(arguments);
    };
    ytag({ type: 'ycl_cookie' });
  }

  private loadFacebookPixelCode() {
    if (typeof document === 'undefined' || environment.facebookAdsId === '') {
      return;
    }
    const script = this.dom.createElement('script');
    const noScript = this.dom.createElement('noscript');
    script.innerHTML = `
      !function(f,b,e,v,n,t,s)
      {if(f.fbq)return;n=f.fbq=function(){n.callMethod?
      n.callMethod.apply(n,arguments):n.queue.push(arguments)};
      if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
      n.queue=[];t=b.createElement(e);t.async=!0;
      t.src=v;s=b.getElementsByTagName(e)[0];
      s.parentNode.insertBefore(t,s)}(window, document,'script',
      'https://connect.facebook.net/en_US/fbevents.js');
      fbq('init', '${environment.facebookAdsId}');
      fbq('track', 'PageView');
    `;
    noScript.innerHTML = `
      <img height="1" width="1" style="display:none" src="https://www.facebook.com/tr?id=${environment.facebookAdsId}&ev=PageView&noscript=1" />
    `;
    this.dom.head.appendChild(script);
    this.dom.head.appendChild(noScript);
  }

}
